import { Component, OnInit } from '@angular/core';
import { AwardService } from '../../../../core/services/awards/awards.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-jury',
    templateUrl: './jury.component.html',
    styleUrls: ['./jury.component.scss']
})
export class JuryComponent implements OnInit {
    juryList: any = []
    selectedJury: any;
    selectedIndex: any = 0;
    isSideBarOpen: boolean = false
    version: any = [];
    allVersions: any = [];
    isArchive:boolean=false;

    constructor(public awardService: AwardService, private router: Router) { }

    ngOnInit(): void {
        if(this.router.url.includes('/archive')){
            this.isArchive = true;
        }
        this.awardService.getAllCurrentJury().subscribe((res: any) => {
            this.juryList = res;
            this.selectedJury = this.juryList.cinejoyJudges[0];
        }, err => {

        })
        this.getAllVersion()
    }

    onClickOfItem(event: any, index: any) {
        this.selectedJury = event;
        this.selectedIndex = index;
    }

    onToggleSideNav() {
        this.isSideBarOpen = !this.isSideBarOpen;
    }

    getAllVersion() {
        this.awardService.getAllAwardsVersion().subscribe(data => {
            this.allVersions = data.awardsVersions;
            this.version = this.allVersions.find((v) => v.isCurrent == 1)['id'];
        }, err => {

        })
    }

    onChangeVersion(event: any) {
        this.awardService.getArchivedJuryByVersion(this.version).subscribe(data => {
            this.juryList = data;
            this.selectedJury = this.juryList?.cinejoyJudges[0];
            this.selectedIndex = 0;
        }, err => {
            alert("Error while fetching data")
        })
    }

    navigateBack(){
        if(this.isArchive){
            this.router.navigateByUrl('/cinejoy/archive/awards')
        }else{
            this.router.navigateByUrl('/cinejoy/awards')
        }
    }


}